import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import IntegrationModel from 'cio/models/integration';

export default class IntegrationTypeController extends Controller {
  @service analytics!: AnalyticsService;

  model!: IntegrationModel;
  public = false;
  showNotify = false;

  queryParams = ['showNotify'];

  @action
  trackClick(evt: MouseEvent) {
    if ((evt.target as HTMLElement)?.tagName !== 'A') {
      return;
    }

    let anchor = evt.target as HTMLAnchorElement;
    let href = anchor.getAttribute('href');

    this.analytics.track('integration', 'use_case_link_clicked', {
      from: 'In-App',
      category: this.model.category,
      name: this.model.name,
      type: this.model.type,
      url: href!,
    });
  }
}
